var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-end"},[_c('Logo',{staticClass:"main-logo",attrs:{"src":require('../assets/Logosnetto-logo_tile.png'),"href":_vm.platformLogoHref}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary logo-button",attrs:{"type":"button"}},[_vm._v("Vorteilswelt")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }